import React, { useRef } from "react";
import { Modal } from "react-bootstrap";
import AsyncSelect from 'react-select/async';

const selectStyle = {
    theme: theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
            ...theme.colors,
            primary25: '#92278f',
            primary: '#92278f',
        },
    })
};

const ChangeSchoolModal = ({ show, onClose, user, onSubmit, promiseSchoolOptions, t }) => {
    const schoolsSelectRef = useRef(null);

    if (!show || !user) return null;

    const handleSaveSchool = () => {
        const selected = schoolsSelectRef.current?.select?.select?.getValue();
        const value = selected && selected[0]?.value;
        const label = selected && selected[0]?.label;
        onSubmit(value, label);
    };

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-school text-primary icon ml-2"></i>
                        {user.UserType?.Id === 2 ? (
                            t("Pages.UsersControl.action.changeTypeToSchoolTeacher")
                        ) : (
                            <>
                                {t("Pages.UsersControl.action.changeSchool")}:
                                <span className="text-primary mr-1">{user.Name}</span>
                            </>
                        )}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category mb-2">
                    <div className="widget-body">
                        <div className="form-group w-100">
                            <AsyncSelect
                                cacheOptions
                                isClearable={true}
                                name="SchoolsId"
                                placeholder={t('Pages.UsersControl.advancedSearch.School')}
                                isRtl={true}
                                isSearchable={true}
                                defaultOptions
                                loadOptions={promiseSchoolOptions}
                                ref={schoolsSelectRef}
                                {...selectStyle}
                            />
                        </div>
                        <div className="form-group w-100 text-center">
                            <button className="custom-button btn-block" onClick={handleSaveSchool}>
                                <span>
                                    <i className="icon fal fa-save ml-1"></i>
                                    {t('Pages.UsersControl.notes.Send')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangeSchoolModal;
